import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import classNames from 'classnames';
import { Set, List } from 'immutable';

import { Popup } from '../Popup';
import Checkbox from './Checkbox';

class MultiSelect extends Component {
  constructor (props) {
    super(props);

    this.state = {
      opened: false,
      value: props.value,   // строка с id: 1,2,3
      search: '',
      searchableItems: props.items,
    };

    this.throttlingTimer = null;

    this.name = props.name;
    this.label = props.label;
    this.items = props.items;
    this.selectItems = Set(props.value ? props.value.split(',') : []);

    this.placeholder = props.placeholder;
    this.staticButtonText = props.staticButtonText;
    this.silenceLimit = props.silenceLimit;
    this.silenceEnabled = props.silenceEnabled;
    this.silencePrefix = props.silencePrefix;
    this.text = this.placeholder;
    this.onUpdate = props.onUpdate;
    this.scrolling = props.scrolling;
    this.searchable = props.searchable;

    this.updateText = this.updateText.bind(this);
    this.renderMenu = this.renderMenu.bind(this);
    this.isSelectedItem = this.isSelectedItem.bind(this);
    this.handlerSelect = this.handlerSelect.bind(this);
    this.handleOpenPopup = this.handleOpenPopup.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.renderSearch = this.renderSearch.bind(this);
    this.renderArrowButton = this.renderArrowButton.bind(this);
    this.handleSearch = this.handleSearch.bind(this);

    this.updateText();
  }

  componentWillReceiveProps (nextProps, nextContext) {
    if (!(new List(this.props.items)).equals(new List(nextProps.items))) {
      this.items = nextProps.items;
    }

    if (nextProps.value !== this.props.value) {
      this.selectItems = Set(nextProps.value ? nextProps.value.split(',') : []);
      this.updateText();

      this.setState({
        value: nextProps.value
      });
    }
  }

  updateText () {
    if (this.staticButtonText) {
      this.text = this.staticButtonText;
      return;
    }

    const length = this.selectItems.count();

    if (length === 0) {
      this.text = this.placeholder;
    } else if (length > this.silenceLimit && this.silenceEnabled) {
      this.text = this.silencePrefix + ' (' + length + ')';
    } else {
      this.text = this.items
        .filter(item => {
          return this.selectItems.has(String(item.id));
        })
        .map(item => item.shortName || item.name)
        .join(', ');
    }
  }

  isSelectedItem (id) {
    return this.selectItems.has(String(id));
  }

  shouldComponentUpdate (nextProps, nextState) {
    return nextProps.value !== this.state.value || nextState.opened !== this.state.opened || 
    nextState.search !== this.state.search || nextState.searchableItems.length !== this.state.searchableItems.length;
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.state.opened) {
      document.addEventListener('click', this.handleClickOutside);
    } else {
      document.removeEventListener('click', this.handleClickOutside);
    }
  }

  componentWillUnmount () {
    document.removeEventListener('click', this.handleClickOutside);
  }

  handleClickOutside (e) {
    const nodeRef = findDOMNode(this.popupContainer);
    const nodeSearchInputRef = findDOMNode(this.searchInputRef);
    if ((this.popupContainer !== e.target && nodeRef && !nodeRef.contains(e.target) && this.state.opened) &&
    (this.nodeSearchInputRef !== e.target && nodeSearchInputRef && !nodeSearchInputRef.contains(e.target) && this.state.opened)) {
      this.setState({
        opened: false,
        searchableItems: this.items,
        search: ''
       });
    }
    if (this.popupContainer !== e.target && nodeRef && !nodeRef.contains(e.target) && this.state.opened && !this.searchable) {
      this.setState({
        opened: false,
      });
    }
  }

  handleOpenPopup (e) {
    e.preventDefault();

    this.setState({
      opened: !this.state.opened
    });
  }

  handleSearch (e) {
    const value = e.target.value.toUpperCase();
    this.setState({
      search: value
    });
    clearTimeout(this.throttlingTimer);

    this.throttlingTimer = setTimeout(() => {
      const matches = this.items.filter(s => s.name.includes(value));
      this.setState({
        searchableItems: matches
      });
    }, 300);
  }

  handlerSelect (id, state) {
    const ids = state
      ? this.selectItems.add(String(id))
      : this.selectItems.delete(String(id));

    this.onUpdate(this.name, ids.isEmpty() ? null : ids.join(','));
  }

  renderMenu () {
    const { opened, searchableItems } = this.state;

    return (
      <Popup
        indentation={false}
        opened={opened} direction='bottom-left'
        mainOffset={0} secondaryOffset={0} ref={p => { this.popupContainer = p; }}
      >
        <ul
          className={'multiselect-control-list' + (this.scrolling ? ' scrolling' : '')}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          { this.searchable ?
            searchableItems.map(item => (
              <li key={item.id} className={'item item-' + item.id} >
                <Checkbox
                  key={item.id}
                  id={item.id}
                  label={item.name}
                  checked={this.isSelectedItem(item.id)}
                  onUpdate={this.handlerSelect} />
              </li>
            ))
            :
            this.items.map(item => (
              <li key={item.id} className={'item item-' + item.id} >
                <Checkbox
                  key={item.id}
                  id={item.id}
                  label={item.name}
                  checked={this.isSelectedItem(item.id)}
                  onUpdate={this.handlerSelect} />
              </li>
            ))
          }
        </ul>
      </Popup>
    );
  }

  renderSearch() {
    const { search, opened } = this.state;
    return (
      <Fragment>
        {opened ?
          <input
            className='text-base'
            autoFocus
            onChange={this.handleSearch}
            type='text'
            value={search}
            ref={p => { this.searchInputRef = p; }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          />
          :
          this.renderArrowButton()
        }
      </Fragment>
    )
  }

  renderArrowButton() {
    const arrowClass = classNames(
      'button-select-value', 'button-flat', {
        'value-empty': !this.label,
        'down': !this.state.opened,
        'up': this.state.opened
      });

    const textClass = classNames({
      'placeholder': this.selectItems.isEmpty() && !this.staticButtonText
    });

    return (
      <button className={arrowClass} type='button'>
        <span className={textClass}>{this.text}</span>
      </button>
    )
  }

  render () {
    return (
      <div className={'multiselect-control-box ' + this.name}>
        {this.label || ''}
        <div className='multiselect-control-value' onClick={this.handleOpenPopup}>
          {this.searchable ? 
            this.renderSearch()
            :
            this.renderArrowButton()
          }
          {this.state.opened && this.renderMenu()}
        </div>
      </div>
    );
  }
}

const itemType = PropTypes.shape({
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  name: PropTypes.string.isRequired,
  shortName: PropTypes.string
});

MultiSelect.propTypes = {
  items: PropTypes.arrayOf(itemType).isRequired,
  name: PropTypes.string.isRequired,              // имя свойства, которое меняет селект
  label: PropTypes.string,                        // название селекта
  value: PropTypes.string,                        // текущиее выбранное значение
  placeholder: PropTypes.string,                  // текст для случая когда ничего не выбранно
  staticButtonText: PropTypes.string,             // если есть, то надпись на кнопке всегда берется из него
  silenceEnabled: PropTypes.bool,                 // тихий режим: "silencePrefix (N)"
  silencePrefix: PropTypes.string,                // префикс для тихого режима
  silenceLimit: PropTypes.number,                 // кол-во элементов, которые не надо гасить через silenceEnabled
  onUpdate: PropTypes.func.isRequired,            // callback(name, item.value)
  scrolling: PropTypes.bool,
  searchable: PropTypes.bool,
};

MultiSelect.defaultProps = {
  label: '',
  value: null,
  placeholder: 'Неважно',
  staticButtonText: '',
  silenceEnabled: false,
  silencePrefix: '',
  silenceLimit: 3,
  scrolling: false,
  searchable: false,
};

export default MultiSelect;



// WEBPACK FOOTER //
// ./src/ui/Controls/MultiSelect.jsx